export interface ISearchParamsCache {
  status?: string;
  propType?: string;
  listPriceRangeLow?: string;
  listPriceRangeHigh?: string;
  leasePriceRangeLow?: string;
  leasePriceRangeHigh?: string;
  bedrooms?: string;
  sizeRangeLow?: string;
  sizeRangeHigh?: string;
  descriptionKeywords?: string;
  parkingSpaces?: string;
  openHouse?: string;
  basement?: string;
  daysOnMarket?: string;
  lotFrontageRangeLow?: string;
  lotFrontageRangeHigh?: string;
  bathrooms?: string;
  streetNumberStart?: string;
  streetNumberEnd?: string;
  streetName?: string;
  city?: string;
  unitNumber?: string;
  provinceState?: string;
  postalCodeZip?: string;
  geo_city?: string;
  geo_state?: string;
  geo_street_no?: string;
  geo_street?: string;
  geo_street_suffix?: string;
  geo_community?: string;
  x?: string;
}

export const defaultValue: Readonly<ISearchParamsCache> = {
};
